import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, Button, Badge, Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import image from '../../assets/images/codegenerator.jpg';
import AssessmentFlow from "../assessment/AssessmentFlow";


const MotionBox = motion(Box);

const ExperiencedHero = ({ data }) => {
  return (
    <Box
      minH="90vh"
      bgGradient="linear(to-br, brand.700, brand.900, accent.green)"
      position="relative"
      overflow="hidden"
    >
      {/* Blur effects */}
      <Box
        position="absolute"
        top="15%"
        right="10%"
        w="400px"
        h="400px"
        bg="accent.gold"
        opacity="0.1"
        borderRadius="full"
        filter="blur(100px)"
      />
      <Box
        position="absolute"
        bottom="10%"
        left="5%"
        w="500px"
        h="500px"
        bg="accent.green"
        opacity="0.15"
        borderRadius="full"
        filter="blur(120px)"
      />

      <Container maxW="container.xl" pt={{ base: 32, md: 40 }} pb={20}>
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <VStack spacing={6} align="center" textAlign="center">
            <Badge
              px={4}
              py={2}
              bg="accent.gold"
              color="brand.800"
              fontSize="sm"
              fontWeight="700"
              borderRadius="full"
            >
              {data.badgeText}
            </Badge>
            
            <Heading
              as="h1"
              fontSize={{ base: '4xl', md: '5xl', lg: '6xl' }}
              fontWeight="900"
              color="white"
              lineHeight="1.1"
            >
              {data.title}
            </Heading>
            
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color="whiteAlpha.900"
              maxW="3xl"
            >
              {data.description}
            </Text>

            {/* Video placeholder */}
            <Box
              w={{ base: 'full', md: '600px' }}
              borderRadius="2xl"
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              _hover={{ transform: 'scale(1.15)' }}
              transition="all 0.3s"
            >
                          <Image
                      src={image}
                      alt="Students smiling during a hero-students program"
                      borderRadius="lg" // Example of a Chakra UI style prop
                    />
              
            </Box>

            <HStack spacing={4} pt={4} flexWrap="wrap" justify="center">
              <AssessmentFlow />
            </HStack>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default ExperiencedHero;